import React from 'react';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';

const LoadingPage = () => {
  return (
    <div>
      <LoadingSpinner />
    </div>
  );
};

export default LoadingPage;
